import { FORM_ELEMENT_BLOCK_CLASSNAME_ERROR } from '@vfde-brix/ws10/form-element';
import { trackValidationError } from '../tracking';
import { validateFormControlInput } from './customInputValidator.helper';
import { AppId, LmsInputId } from '../../../enums/elementId';

const isTextInputValidationError = () => {
    const form = document.getElementById(AppId.ID_WRAPPER_LMS_FORM);

    if (!form) {
        return true;
    }

    const elementsWithError = form.getElementsByClassName(FORM_ELEMENT_BLOCK_CLASSNAME_ERROR);

    // track validation errors
    try {
        for (let i = 0; i < elementsWithError.length; i++) {
            const wrapperElement = elementsWithError.item(i) as HTMLDivElement;
            const input = wrapperElement?.getElementsByTagName('input')[0];

            //  "...only send one error event for a single validation error..."
            0 === i && trackValidationError(input.name);
        }
    } catch (e) {
        // skip
    }

    return 0 !== elementsWithError.length;
};

/**
 * Goes through all inputs of the form
 * returns with 'true' if there are no validation errors
 * returns 'false' otherwise.
 * @returns boolean
 */
export const validateForm = (): boolean => {
    const elementsToValidate = [
        LmsInputId.ID_WRAPPER_INPUT_CONTACT_METHOD,
        LmsInputId.ID_WRAPPER_INPUT_GENDER,
        LmsInputId.ID_WRAPPER_INPUT_CONSENT_PRIVACY_POLICY,
    ];

    for (const inputName of elementsToValidate) {
        // Note: loop through every input to dispatch their validation error messages
        if (!validateFormControlInput(document.getElementById(inputName) as HTMLDivElement)) {
            // Note: Only send one error event for a single validation error
            trackValidationError(inputName);

            return false;
        }
    }

    return !isTextInputValidationError();
};

export const isString = (value: unknown): value is string =>
    'string' === typeof value;
